import { render, staticRenderFns } from "./FormContent.vue?vue&type=template&id=5f9761a3&scoped=true&"
import script from "./FormContent.vue?vue&type=script&lang=js&"
export * from "./FormContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9761a3",
  null
  
)

export default component.exports